




















































import { Dictionary } from "lodash";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { ApiMessage, TreatmentRequestsApi } from "../../../apis";
import MyDateTimePickerMobile from '../mobile/common/MyDateTimePickerMobile.vue';

@Component({
components: { ValidationProvider, ValidationObserver, MyDateTimePickerMobile },
})
export default class ContinueTreatmentDialog extends Vue {
@Prop({}) selectedTreatmentRequest: any;
@Prop({ default: false }) value: Boolean;
@Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

startDate = "";
startImmediately = false;

get confirmContent() {
  return !this.selectedTreatmentRequest ? "" : this.lodash.template(
      `${this.$t("dialog.continueTreatmentRequest.content")}`
    )({ number: this.selectedTreatmentRequest.number });
}

get show() {
  return this.value;
}

set show(value) {
  this.$emit("input", value);
}

get apiMessages(): Dictionary<ApiMessage[]> {
  return this.$store.getters.apiMessages;
}

@Watch("apiMessages", { deep: true })
apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
  this.$util.showApiError(messages, this.observer);
}

onChangeStartImmediately(val) {
  if (val) {
    this.startDate = null;
  }
}

async onSubmit() {
  const isValid = await this.observer.validate();
  if (!isValid) {
    this.$util.goToErrorField(this.observer);
    return;
  }
  this.$util.showLoading();
  try {
    await new TreatmentRequestsApi().continueTreatmentRequest({
      id: this.selectedTreatmentRequest._id,
      putContinueTreatmentRequestRequest: {
        id: this.selectedTreatmentRequest._id,
        startDate: !this.startDate
          ? ""
          : moment(this.startDate, "YYYY-MM-DD HH:mm")
              .utc()
              .format("YYYY-MM-DD HH:mm"),
        unitId: this.selectedTreatmentRequest.unit._id,
      },
    });
    this.submitted();
  } catch (error) {
    this.$util.showError(error);
  } finally {
    this.$util.hideLoading();
  }
}

// doCheckValidDate(): boolean {
//   const startDate = moment(this.startDate);
//   const endDate = moment(this.endDate);
//   const currentDate = moment(new Date());
//   if (startDate < currentDate) {
//     this.invalidMsgStartDate = this.$t("message.invalid");
//     return false;
//   }
//   if (startDate > endDate) {
//     this.invalidMsgEndDate = this.$t("message.invalid");
//     return false;
//   }
//   this.invalidMsgStartDate = "";
//   this.invalidMsgEndDate = "";
//   return true;
// }

onCancel() {
  this.show = false;
}

submitted() {
  this.$emit("submitted", true);
}
}
